import { ClientUIModule } from "@services/api/types";
import ROUTES, { ROUTING_MMM_MODEL, ROUTING_SIMULATOR } from "./routing";

export interface WavesModuleConfig {
  path: string;
  label: string;
  orderId: number;
  id: ClientUIModule;
}

export const WAVES_MODULES_CONFIG: { [key: string]: WavesModuleConfig } = {
  [ROUTING_MMM_MODEL]: {
    path: ROUTES.MMM_MODEL,
    label: "navbar.tabs.mmm_model",
    orderId: 1,
    id: "modeling"
  },
  [ROUTING_SIMULATOR]: {
    path: ROUTES.SIMULATOR,
    label: "navbar.tabs.simulator",
    orderId: 2,
    id: "simulator"
  }
};
